import { actionTypes } from './constants';

export const hubConnectionPromptActionTypes = {
  show: actionTypes.SHOW_HUB_CONNECTION_PROMPT_POPUP,
  hide: actionTypes.HIDE_HUB_CONNECTION_PROMPT_POPUP,
};
